import { Link } from "react-router-dom";
import { PawPrint } from "lucide-react";

export const Footer = () => {
  return (
    <footer className="border-t border-white/10 bg-background">
      <div className="mx-auto max-w-7xl px-6 py-14 lg:px-8">
        <div className="grid gap-8 md:grid-cols-3">
          <div>
            <div className="flex items-center gap-2">
              <span className="flex h-8 w-8 items-center justify-center rounded-sm bg-primary text-primary-foreground">
                <PawPrint className="h-5 w-5" />
              </span>
              <span className="font-display text-2xl uppercase tracking-wider text-white">
                Clawius
              </span>
            </div>
            <p className="mt-3 max-w-xs font-body text-sm leading-relaxed text-zinc-400">
              Results-driven dog training. Enroll your dog and keep an accurate,
              consent-backed record on file.
            </p>
          </div>

          <div>
            <p className="font-heading text-xs font-semibold uppercase tracking-[0.25em] text-zinc-500">
              Company
            </p>
            <ul className="mt-4 space-y-2 font-body text-sm">
              <li><Link to="/" className="text-zinc-400 hover:text-primary">Enroll a Dog</Link></li>
              <li><Link to="/about" className="text-zinc-400 hover:text-primary">About</Link></li>
              <li><Link to="/contact" className="text-zinc-400 hover:text-primary">Contact</Link></li>
            </ul>
          </div>

          <div>
            <p className="font-heading text-xs font-semibold uppercase tracking-[0.25em] text-zinc-500">
              Legal
            </p>
            <ul className="mt-4 space-y-2 font-body text-sm">
              <li><Link to="/terms" className="text-zinc-400 hover:text-primary">Terms of Service</Link></li>
              <li><Link to="/privacy" className="text-zinc-400 hover:text-primary">Privacy Policy</Link></li>
              <li><Link to="/sms-terms" className="text-zinc-400 hover:text-primary">SMS Terms</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-start justify-between gap-3 border-t border-white/10 pt-6 font-body text-sm text-zinc-500 md:flex-row md:items-center">
          <p>© {new Date().getFullYear()} Clawius. All rights reserved.</p>
          <p>Consent-first. Duplicate-protected. Records kept private.</p>
        </div>
      </div>
    </footer>
  );
};
